import { z } from 'zod';
import { SearchSchema as BulkAppUserOperationSchema } from './-components/BulkAppUserOperation/-zod-schemas';

// 全スキーマを合成するしかないのか...
export const SearchSchema = BulkAppUserOperationSchema.extend({
  operationPackagePatternId: z.string().optional()
});
export type SearchParams = z.infer<typeof SearchSchema>;